module.exports = __webpack_public_path__ + "static/media/NoPos.1317823b.svg";